import {
    AfterViewInit,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
    ViewChildren
} from '@angular/core';
import { PinCodeService } from 'src/app/services/pin-code.service';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'shc-pincode-input',
    templateUrl: './pincode-input.component.html',
    styleUrls: ['./pincode-input.component.scss'],
})
export class PincodeInputComponent implements OnChanges, AfterViewInit {
    public pinCodeArray: any[];
    public pinCodeFormGroup: UntypedFormGroup;
    @ViewChildren('name') pinInput;
    @Input() color: string;
    @Input() isHidden = false;
    @Input() codeSize = 4;
    @Output() completed = new EventEmitter<string>();

    constructor(private pinCodeService: PinCodeService) {
        this.initiateBuilder();
        this.pinCodeService.reset$.subscribe(val => {
            if (val === true) {
                this.pinCodeFormGroup.reset();
            }
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        const stylebody = document.body.style;
        if (changes.color !== undefined) {
            stylebody.setProperty('--borderColor', changes.color.currentValue);
        }
        if (changes.isHidden !== undefined) {
            if (changes.isHidden.currentValue === false) {
                stylebody.setProperty('--charShape', 'none');
            } else {
                stylebody.setProperty('--charShape', 'disc');
            }
        }

        this.initiateBuilder();

    }

    initiateBuilder() {
        this.pinCodeFormGroup = new UntypedFormGroup({});

        for (let i = 0; i < this.codeSize; i++) {
            const formController: UntypedFormControl = new UntypedFormControl({ value: '', disabled: true }, [Validators.required]);
            this.pinCodeFormGroup.addControl('codeFiled' + i, formController);
        }

        const v_pinCodeArray: any[] = [];
        Object.keys(this.pinCodeFormGroup.value).forEach((key) => {
            v_pinCodeArray.push(key);
        });

        this.pinCodeArray = v_pinCodeArray;
        this.pinCodeFormGroup.get('codeFiled0').enable();
    }

    ngAfterViewInit() {
        // const input: HTMLElement = document.querySelectorAll('.pinCodeInput').item(0) as HTMLElement;
        // input.focus();
        this.pinInput.toArray()[0].nativeElement.focus();
    }


    onKeyUp($event: any, item: any, index: any) {
        let v_index;

        const reg = new RegExp('[0-9]');

        if ($event.key === 'Backspace') {
            if (index === 0) {
                v_index = 0;
            } else {
                v_index = index - 1;
            }
        } else {
            if (reg.test($event.target.value)) {

                if (index === this.codeSize - 1) {
                    v_index = this.codeSize - 1;
                } else {
                    v_index = index + 1;
                    this.pinCodeFormGroup.get('codeFiled' + v_index).enable();
                    // this.pinCodeFormGroup.get(item).setValue($event.target.value);
                }
            }
        }
        // const input: HTMLElement = document.querySelectorAll('.pinCodeInput').item(v_index) as HTMLElement;
        // input.focus();
        if (v_index >= 0) {
            this.pinInput.toArray()[v_index].nativeElement.focus();
        }


        if (index === this.codeSize - 1 && $event.key !== 'Backspace') {
            let pinCodeValue = '';
            Object.keys(this.pinCodeFormGroup.value).forEach((key) => {
                pinCodeValue += this.pinCodeFormGroup.value[key];
            });

            if (this.pinCodeFormGroup.valid) {
                this.completed.emit(pinCodeValue);
            } else {

            }
        }

    }

    onKeyDown($event: any) {
        if ($event.key !== 'Backspace') {

            if ($event.target.value.length === 1) {
                return false;
            }

        }
    }
}
